import { LoginForm } from '@/features/auth/components/LoginForm';
import { Card, CardDescription, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Link } from 'react-router-dom';
import { Label } from '@/features/label/components/label';
import { LabelGroup } from '@/features/label/types';

export function Login() {
  return (
      <Card
        className="
        w-full
        max-w-md
        md:max-w-xl
        lg:max-w-3xl
        xl:max-w-4xl
        p-6
        bg-card
        shadow-md
      ">
        <CardTitle className="text-center text-2xl font-bold">
          <Label name="login_title" groupName={LabelGroup.LOGIN} />
        </CardTitle>
        <CardDescription className="text-left text-sm">
          <Label name="login_description" groupName={LabelGroup.LOGIN} />
        </CardDescription>
        <Separator />
        <LoginForm />
        <Separator />
        <div className="flex flex-col space-y-2 text-center">
          <Link to={'/register' + window.location.search} className="underline text-sm">
            <Label name="i_dont_have_an_account" groupName={LabelGroup.LOGIN} />
          </Link>
          <Link to="/forgot-password" className="underline text-sm">
            <Label name="forgot_password" groupName={LabelGroup.LOGIN} />
          </Link>
        </div>
      </Card>
  );
}
